export class Report {
    id: any;
    name: string;
    // {service, dataFormat, columns}
    dataSets: Array<any> = [];
    // Name
    columns: Array<any> = [];
}
